export const MODULE_PREFIX = 'products';
